import intersection from "lodash/intersection"
import type { TUser, TVisibility } from "@/types"

interface UserProps {
  role?: TUser["role"]
  is_super?: TUser["is_super"]
}

export const hasSuper = ({ is_super }: UserProps = {}) => !!is_super

export const hasOwner = ({ role }: UserProps = {}) => role === "owner"

export const hasAdmin = ({ role }: UserProps = {}) => role === "admin" || hasOwner({ role })

export const hasManager = ({ role }: UserProps = {}) => role === "manager" || hasAdmin({ role })

export const hasUserManager = (auth: TUser, user: TUser) => {
  if (auth.is_super || hasOwner(auth)) return true
  if (hasAdmin(auth)) return !hasOwner(user)
  if (auth.role === "manager") return !!intersection(auth.team_ids, user.team_ids).length
  return auth.id === user.manager_id
}

export const hasVisibility = (visibility: TVisibility, { role, is_super }: UserProps = {}) => {
  if (is_super || hasAdmin({ role })) return true
  if (visibility === "public") return true
  if (visibility === "managers") return hasManager({ role })
  return false
}
